import { render } from "./IconCopy.vue?vue&type=template&id=e1287126"
const script = {}
script.render = render

export default script